import { createAction, props } from '@ngrx/store';

import { SensorActuatorBarnMapping } from '../../models/farm-result.model';
import {
  Barn,
  DiscountSettings,
  FinalSetupSettings,
  MasterDataSettings,
  RVSSettings,
  UnitOfMeasureSettings,
  VeterinarianSettings,
} from '../../models/setting.model';

/** DAY OFFSET ACTION */
export const loadDayOffset = createAction('[DayOffset] Load DayOffset');

export const setDayOffset = createAction(
  '[DayOffset] Set DayOffset',
  props<{ dayOffset: number; save: boolean }>(),
);

/** OBSERVATION SWITCH ACTION */
export const loadObservationSwitch = createAction('[ObservationSwitch] Load Observation Switch');

export const setObservationSwitch = createAction(
  '[ObservationSwitch] Set Observation Switch',
  props<{ observationSwitch: boolean; save: boolean }>(),
);

/** BARN SETTING ACTIONS */
export const loadBarnsRequest = createAction('[Barn] Load barns request');
export const loadBarnsSuccess = createAction(
  '[Barn] Load barns success',
  props<{ barns: Barn[] }>(),
);
export const loadBarnsFailed = createAction('[Barn] Load barns failed', props<{ error: Error }>());

export const upsertBarnRequest = createAction(
  '[Barn] Upsert barn request',
  props<{ barn: Barn }>(),
);
export const upsertBarnSuccess = createAction(
  '[Barn] Upsert barn success',
  props<{ barn: Barn }>(),
);
export const upsertBarnFailed = createAction(
  '[Barn] Upsert barn failed',
  props<{ error: Error }>(),
);

export const deleteBarnRequest = createAction(
  '[Barn] Delete barn request',
  props<{ barn: Barn }>(),
);
export const deleteBarnWithConfirmation = createAction(
  '[Barn] Confirm Delete barn',
  props<{ barn: Barn }>(),
);
export const deleteBarnSuccess = createAction(
  '[Barn] Delete barn success',
  props<{ barn: Barn }>(),
);
export const deleteBarnFailed = createAction(
  '[Barn] Delete barn failed',
  props<{ error: Error }>(),
);

export const upsertBarn = createAction('[Barn] Upsert barn', props<{ barn: Barn }>());
export const setSelectedBarn = createAction(
  '[Barn] Set Selected barn',
  props<{ barnId?: number }>(),
);

/** RVS SETTING ACTIONS */
export const loadTemperatureInsideSetting = createAction(
  '[RVSSetting] Load Temperature Inside Setting',
);
export const loadFeedIntakeSetting = createAction('[RVSSetting] Load Feed Intake Setting');
export const loadWaterIntakeSetting = createAction('[RVSSetting] Load Water Intake Setting');
export const loadWeightSetting = createAction('[RVSSetting] Load Weight Setting');

export const loadRVSSettings = createAction('[RVSSetting] Load RVS Settings');
export const setRVSSettings = createAction(
  '[RVSSetting] Set RVS Settings',
  props<{ value: RVSSettings; save: boolean }>(),
);

export const loadUnitOfMeasureSettings = createAction(
  '[UnitOfMeasureSetting] Load Unit of Measure Settings',
);
export const setUnitOfMeasureSettings = createAction(
  '[UnitOfMeasureSetting] Set Unit of Measure Settings',
  props<{ value: UnitOfMeasureSettings; save: boolean }>(),
);

/** Farm Result SETTING ACTIONS */
export const loadFarmResultSettingsRequest = createAction(
  '[FarmResult] Load FarmResultSettings request',
);
export const loadFarmResultSettingsSuccess = createAction(
  '[FarmResult] Load FarmResultSettings success',
  props<{ sensorActuatorBarns: SensorActuatorBarnMapping[] }>(),
);
export const loadFarmResultSettingsFailed = createAction(
  '[FarmResult] Load barns failed',
  props<{ error: Error }>(),
);

export const upsertFarmResultSettingsRequest = createAction(
  '[FarmResult] Upsert FarmResultSettings request',
  props<{ sensorActuatorBarns: SensorActuatorBarnMapping[] }>(),
);
export const upsertFarmResultSettingsSuccess = createAction(
  '[FarmResult] Upsert FarmResultSettings success',
  props<{ sensorActuatorBarns: SensorActuatorBarnMapping[] }>(),
);
export const upsertFarmResultSettingsFailed = createAction(
  '[FarmResult] Upsert FarmResultSettings failed',
  props<{ error: Error }>(),
);

/** Veterinarian Settings Actions **/
export const upsertVeterinarianSettings = createAction(
  '[Barn] Upsert veterinarian settings',
  props<{ veterinarianSettings: VeterinarianSettings }>(),
);
export const loadVeterinarianSettings = createAction('[Barn] Set selected veterinarian');

/** Final Setup Settings **/
export const setFinalSetupSettings = createAction(
  '[FinalSetupSettings] Set Final Setup Settings',
  props<{ value: FinalSetupSettings; save: boolean }>(),
);

export const loadFinalSetupSettings = createAction(
  '[FinalSetupSettings] Load Final Setup Settings',
);

export const upsertMasterDataRequest = createAction(
  '[MasterData] Upsert MasterData request',
  props<{ masterData: MasterDataSettings }>(),
);

/* Discount settings */
export const loadDiscountSettings = createAction('[DiscountSettings] Load Discount Settings');

export const upsertDiscountSettings = createAction(
  '[DiscountSettings] Upsert Discount Settings',
  props<{ discountSettings: DiscountSettings }>(),
);

export const setDiscountSettigs = createAction(
  '[DiscountSettings] Set Discount Settings',
  props<{ discountSettings: DiscountSettings }>(),
);
